class BaseDisclosureController {
    constructor(_, $location, $state, $q, className, disclosureType, reviewPath, preFetchedData, componentDataService, componentRegistryService, disclosureService, fileSaver, loggerService) {
        this._ = _;
        this.location = $location;
        this.state = $state;
        this.q = $q;
        this.className = className;
        this.disclosureType = disclosureType;
        this.reviewPath = reviewPath;
        this.disclosureData = preFetchedData.disclosureData || {};
        this.componentDataService = componentDataService;
        this.componentRegistryService = componentRegistryService;
        this.disclosureService = disclosureService;
        this.fileSaver = fileSaver;
        this.loggerService = loggerService;
        this.componentDataService.setDto(preFetchedData);
    }   

    save() {
        let data = this.componentDataService.getDto(this.disclosureType);
        data.id = this._.get(this.disclosureData, "id", 0);
        let currentId = data.id;

        this.saveDisclosure(data).then((response) => {
            if (response.success) {
                this.loggerService.logSuccess("Your disclosure has been saved.", null, this.className, true);

                if (!currentId) {
                    this.disclosureData.id = response.data.id;
                    this.location.path(`${this.location.path()}${response.data.id}`);
                }
            }
        });
    }

    next() {
        this.validateAll().then((isValid) => {
            if (isValid) {
                let data = this.componentDataService.getDto(this.disclosureType);
                data.id = this._.get(this.disclosureData, "id", 0);
                let currentId = data.id;

                this.saveDisclosure(data).then((response) => {
                    if (response.success) {
                        this.state.go(this.reviewPath, { disclosureId: response.data.id || currentId });
                    }
                });
            }
            return;
        }
        );
    }

    canCancel() {
        if (this.disclosureData.id > 0) {
            if (this.disclosureData.status === "Draft" && !this.disclosureData.history) {
                return true;
            }
            return false;
        }
        return true;
    }

    openCancel() {
        let cancelDisclosure = confirm('Are you sure you want to cancel this disclosure?');

        if (cancelDisclosure) {
            let disclosureId = this.disclosureData.id;
            if (disclosureId > 0) {
                this.disclosureService.cancelDisclosure(disclosureId).then((submitResponse) => {
                    if (this._.isEmpty(submitResponse.error)) {
                        this.state.go("/.coi.mydisclosures");
                    } else {
                        this._handleError(submitResponse.error);
                    }
                });
            }
            this.state.go("/.coi.mydisclosures");
        }
    }

    saveDisclosure(dto) {
        return this.disclosureService.saveDisclosure(dto).then((response) => {
            if (this._.isEmpty(response.error)) {
                return { success: true, data: response.data };
            } else {
                this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                return { success: false };
            }
        });
    }

    validateAll() {
        //TODO: Update some of this once the preview work has been completed.
        let promises = [];
        let components = this.componentRegistryService.getRegistered();

        components.forEach(function (comp) {
            if (comp.validateAsync) {
                promises.push(comp.validateAsync());
            }
        });

        return this.q.all(promises).then((results) => {
            return this._.find(results, (r) => { return r === false }) === undefined;
        });
    }

    onFileUpload(file) {
        let data = this.componentDataService.getDto(this.disclosureType);
        data.id = this._.get(this.disclosureData, "id", 0);
        let currentId = data.id;

        this.saveDisclosure(data).then((response) => {
            if (response.success) {
                this.loggerService.logSuccess("Your disclosure has been saved.", null, this.className, true);

                if (currentId === 0) {
                    this.disclosureData.id = response.data.id;
                }

                let dto = { disclosureId: this.disclosureData.id, file: file };
                this.saveFile(dto, currentId === 0);
            }
        });
    }

    saveFile(dto, isNewDisclosure) {
        return this.disclosureService.saveFile(dto).then((response) => {
            if (this._.isEmpty(response.error)) {
                this.disclosureData.discloserFiles = response.data;
            } else {
                if (!response.isValidFile) {
                    this.loggerService.logError("Invalid file.", response.error, this.className, true);
                } else {
                    this.loggerService.logError("An error occured. Please try again later.", response.error, this.className, true);
                }
            }

            if (isNewDisclosure) {
                this.location.path(`${this.location.path()}${dto.disclosureId}`);
            }
        });
    }

    onFileFetched(fileDto) {
        this.disclosureService.getFile(fileDto).then((response) => {
            this.fileSaver.saveAs(response.data, fileDto.fileName);
        });
    }

    onFileDeleted(fileDto) {
        this.disclosureService.deleteFile(fileDto.disclosureId, fileDto.fileId).then((response) => {
            this.disclosureData.discloserFiles =
                this._.filter(this.disclosureData.discloserFiles, (file) => file.id !== fileDto.fileId);
        });
    }
}

export default BaseDisclosureController;


// WEBPACK FOOTER //
// ./app/disclose/base-disclosure.controller.js